<template>
  <div class="my-shifts-view">
    <VContainer class="fill-height">
      <VLayout row wrap align-center justify-center>
        <VFlex xs12 sm8 md6>
          <ShiftVerificationForm
            :error-message="errorMessage"
            :loading="isLoading"
            @verify="handleVerification"
          />
          <SaveLinkInstructions />
        </VFlex>
      </VLayout>
    </VContainer>
  </div>
</template>

<script>
import { VContainer, VLayout, VFlex } from 'vuetify/lib'
import lambdaApi from '@services/lambdaApi'

import ShiftVerificationForm from '@components/MyShifts/ShiftVerificationForm.vue'
import SaveLinkInstructions from '@components/MyShifts/SaveLinkInstructions.vue'

const STORAGE_KEY = 'myShiftResult'

export default {
  name: 'MyShiftsView',
  components: {
    VContainer,
    VLayout,
    VFlex,
    ShiftVerificationForm,
    SaveLinkInstructions,
  },
  data() {
    return {
      isLoading: false,
      errorMessage: '',
    }
  },
  methods: {
    async handleVerification({ lastFour, lastName }) {
      this.isLoading = true
      this.errorMessage = ''

      try {
        const response = await lambdaApi.post('laborerShiftLookup', {
          lastFour,
          lastName,
        })

        const data = response.data

        if (data.success) {
          // Store result and navigate to result page with query params for reload
          sessionStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({
              shifts: data.shifts,
              laborerFirstName: data.laborer?.firstName || '',
            })
          )
          this.$router.push({
            name: 'My Shift Details',
            query: { l4: lastFour, ln: lastName },
          })
        } else {
          this.errorMessage =
            data.message || 'Verification failed. Please try again.'
        }
      } catch (error) {
        console.error('Shift lookup error:', error)
        const errorData = error.response?.data
        this.errorMessage =
          errorData?.message ||
          'Unable to look up your shift. Please try again later.'
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.my-shifts-view {
  min-height: 100vh;
  background: linear-gradient(135deg, #5c6b7a 0%, #3d4a5c 100%);
}
</style>
